import React, { useState } from 'react'

const Calcutor = () => {
    const [data, setData] = useState("")

    const getVal = (event) =>{
        console.log(event.target.value)
        setData(data.concat(event.target.value))
    }
    // calculate
    const calculate = () => {
        setData(eval(data).toString())
    }
    // back
    const back = () =>{
        setData(data.slice(0,-1))
    }
    // clear function
    const clear = () => {
        setData("")
    }

  return (
    <>
        <div className="cal-container">
            <div>
                <input type="text" placeholder='0' name="" id="" value={data} />
            </div>

            <button onClick={getVal} value="(">(</button>
            <button onClick={getVal} value=")">)</button>
            <button onClick={getVal} value="%">%</button>
            <button onClick={clear} value="AC">AC</button>

            <button onClick={getVal} value="7">7</button>
            <button onClick={getVal} value="8">8</button>
            <button onClick={getVal} value="9">9</button>
            <button onClick={getVal} value="*">*</button>

            <button onClick={getVal} value="4">4</button>
            <button onClick={getVal} value="5">5</button>
            <button onClick={getVal} value="6">6</button>
            <button onClick={getVal} value="-">-</button>

            <button onClick={getVal} value="1">1</button>
            <button onClick={getVal} value="2">2</button>
            <button onClick={getVal} value="3">3</button>
            <button onClick={getVal} value="+">+</button>

            <button onClick={getVal} value="0">0</button>
            <button onClick={back} value="Back">Back</button>
            <button onClick={calculate} value="=">=</button>
            <button onClick={getVal} value="/">/</button>


        </div>
    </>
  )
}

export default Calcutor